import { defineComponent as a, computed as s, createBlock as n, openBlock as u, resolveDynamicComponent as p, mergeProps as c, withCtx as m, renderSlot as d } from "vue";
import { JSONtoNaiveVars as l } from "./highrise343.mjs";
import { getTextWeightStyles as f, getTextSizeStyles as g } from "./highrise622.mjs";
import { COMPONENT_NAME as y } from "./highrise178.mjs";
const h = a({
  name: y.TEXT,
  inheritAttrs: !1
}), _ = /* @__PURE__ */ a({
  ...h,
  props: {
    size: {
      type: String,
      default: "md"
    },
    weight: {
      type: String,
      default: "regular"
    },
    class: {
      type: String,
      default: void 0
    },
    htmlTag: {
      type: String,
      default: "p"
    },
    type: {
      type: String,
      default: "text"
    }
  },
  setup(r) {
    const t = r, o = s(() => ({
      ...l(g(t.size, t.type)),
      ...l(f(t.weight))
    })), i = s(() => ({
      "hr-text": !0,
      [`hr-text-${t.size}`]: !0,
      [`hr-text-${t.weight}`]: !0,
      [`${t.class}`]: !!t.class
    }));
    return (e, S) => (u(), n(p(r.htmlTag), c({
      class: i.value,
      style: o.value
    }, e.$attrs), {
      default: m(() => [
        d(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "style"]));
  }
});
export {
  _ as default
};
